export function isValidPasswordReset(abbreviation: string) {
    return abbreviation === 'UAU';
}
